import Swal from 'sweetalert2'
import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import { 
  sweetAlertCommonParams, 
  selectedOptionsTextArray,
  createSelect2DynamicOption,
  getNodeInputConnectionsBySocketName,
} from '../../utils/functions'

var isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
var isTeamAddonAvailable = !!window.xitFlowBuilderData.team_member_addon
var messenger_bot_connectivity_thirdparty_webhook = !!window.xitFlowBuilderData.messenger_bot_connectivity_thirdparty_webhook

var team_html_display_class = 'd-none';
if (isTeamAddonAvailable)
  team_html_display_class = '';

var sequence_html_display_class = 'd-none';
if (isSequenceAddonAvailable)
  sequence_html_display_class = '';

var thirdparty_webhook_display_class = 'd-none';
if(messenger_bot_connectivity_thirdparty_webhook)
  thirdparty_webhook_display_class = '';

export const referenceModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.postback_modal_title,
    html:
      '<div class="trigger-trigger-keyword-group trigger-onDemand-field form-group text-left mt-2">' + 
        '<label for="trigger-trigger-keyword">' + lang.trigger_html_info_keywords + '</label>' +
        '<input type="text" class="form-control" id="trigger-trigger-keyword" aria-describedby="trigger-trigger-keyword-help" placeholder="' + lang.trigger_html_placeholder_keywords + '">' +
      '</div>'+

      '<div class="trigger-trigger-keyword-group form-group pb-3 mt-2 text-left">' +
        '<label class="pb-1">' + lang.trigger_html_matching_type + '</label>' +
        '<div class="row">' +
          '<div class="col-12">' +
            '<div class="selectgroup w-100">' +
              '<label class="selectgroup-item pb-2">' +
                '<input type="radio" name="trigger-matching-type" value="exact" class="selectgroup-input" checked="">' +
                '<span class="selectgroup-button">' + lang.trigger_html_exact_match + '</span>' +
              '</label>' +
              
              '<label class="selectgroup-item pb-2">' +
                '<input type="radio" name="trigger-matching-type" value="string" class="selectgroup-input">' +
                '<span class="selectgroup-button">' + lang.trigger_html_string_match + '</span>' +
              '</label>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'+

      '<div class="form-group text-left mt-2">' +
        '<label for="reference-reference-postback">' + lang.postback_html_label_title + '</label>' +
        '<input type="text" id="reference-reference-postback" class="form-control">' +
      '</div>'+
      
      '<div class="form-row">'+
        '<div class="form-group only-for-trigger text-left mt-2 col">' +
          '<div class="d-flex justify-content-between">' +
            '<label for="reference-choose-label">' + lang.button_html_add_label + '</label>' +
            '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.postback_html_label_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.postback_html_label_create_new + '</span>' +
          '</div>' + 
          '<select id="reference-choose-label" class="form-control select2" multiple="">' +
          '</select>' +
        '</div>' +

        '<div class="form-group only-for-trigger text-left mt-2 col">' +
          '<div class="d-flex justify-content-between">' +
            '<label for="reference-remove-label">' + lang.button_html_remove_label + '</label>' +
          '</div>' + 
          '<select id="reference-remove-label" class="form-control select2" multiple="">' +
          '</select>' +
        '</div>' +
      '</div>'+
      
      '<div class="form-row '+ sequence_html_display_class +'">'+
        '<div class="form-group only-for-trigger text-left mt-2 col">' +
          '<label for="reference-choose-sequence">' + lang.button_html_add_sequence + '</label>' +
          '<select id="reference-choose-sequence" class="form-control select2">' +
          '</select>' +
        '</div>' +

        '<div class="form-group only-for-trigger text-left mt-2 col">' +
          '<label for="reference-remove-sequence">' + lang.button_html_remove_sequence + '</label>' +
          '<select id="reference-remove-sequence" class="form-control select2">' +
          '</select>' +
        '</div>' +
      '</div>'+

      '<div class="form-row '+ team_html_display_class +'">'+
        '<div class="form-group only-for-trigger text-left mt-2 col">' +
          '<label for="reference-conversation-group">' + lang.button_html_conversation_group + '</label>' +
          '<select id="reference-conversation-group" class="form-control select2">' +
          '</select>' +
        '</div>' +

        '<div class="form-group only-for-trigger text-left mt-2 col">' +
          '<label for="reference-conversation-user">' + lang.button_html_conversation_user + '</label>' +
          '<select id="reference-conversation-user" class="form-control select2">' +
          '</select>' +
        '</div>' +
      '</div>'+

      '<div class="form-row '+ thirdparty_webhook_display_class +'">'+
        '<div class="form-group only-for-trigger text-left mt-2 col-12">' + 
          '<label for="reference-webhook-url">' + lang.button_html_label_webhook_url + '</label>' +
          '<input type="text" class="form-control" id="reference-webhook-url" aria-describedby="button-button-text-help">' +
        '</div>' +
      '</div>'
      ,

    willOpen: () => {
      var page_table_id = window.xitFlowBuilderData.page_table_id
      var base_url = window.xitFlowBuilderData.base_url
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content'),
      })

      const elementLabel = $('#reference-choose-label')
      const elementLabelRemove = $('#reference-remove-label')
      createSelect2DynamicOption(elementLabel)
      createSelect2DynamicOption(elementLabelRemove)

      if (isSequenceAddonAvailable) {
        showElementsIfActionButtonHasSpecificValues(node)
      }
      hideElementsIfActionButtonIsConnectedBefore(node)

      hideContentIfConnectedWithActionButton(node)

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'reference', instagram_bot_addon },
        success:function(response){
          $("#reference-choose-label").html(response.label_dropdown);
          $("#reference-remove-label").html(response.label_dropdown);
          $("#reference-choose-sequence").html(response.drip_dropdown);
          $("#reference-remove-sequence").html(response.drip_dropdown_remove);

          $('#reference-choose-label').val(oldData.labelIds || '').trigger('change')
          $('#reference-remove-label').val(oldData.labelIdsRemove || '').trigger('change')

          if (isSequenceAddonAvailable) {
            $('#reference-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
            $('#reference-remove-sequence').val(oldData.sequenceIdValueRemove || '').trigger('change')
          }
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_team_and_user',
        dataType: 'JSON',
        data: { page_table_id },
        success:function(response) {
          $("#reference-conversation-user").html(response.team_dropdown);
          $('#reference-conversation-user').val(oldData.conversationUserId || '').trigger('change')
          $("#reference-conversation-group").html(response.role_dropdown);
          $('#reference-conversation-group').val(oldData.conversationGroupId || '').trigger('change')
        }
      })

      // Sets old data if there is any
      $('#reference-reference-postback').val(oldData.title || '')
      $('#reference-webhook-url').val(oldData.buttonWebhookUrl || '')
      $('#reference-choose-label').val(oldData.labelIds || '').trigger('change')

      if (isSequenceAddonAvailable) {
        $('#reference-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
      
        $('#reference-choose-sequence').on('change', function() {
          Swal.resetValidationMessage()
          const currentValue = $(this).val()
          if ('newSequence' === oldData.sequenceIdValue && 'newSequence' !== currentValue) {
            node.referenceNodeNewSequenceValueChangeStatus = true;
            Swal.showValidationMessage(lang.postback_new_html_info_sequence)
          }
        })
      } 

      const triggerKeyword = $('#trigger-trigger-keyword')
      triggerKeyword.val(oldData.triggerKeyword || '')
      if (oldData.triggerMatchingType) {
        $('input[name="trigger-matching-type"][value="' + oldData.triggerMatchingType + '"]').prop('checked', true)
      }

      $('[data-toggle="tooltip"]').tooltip()

    },

    preConfirm: () => {
      const title = $('#reference-reference-postback').val()
      const buttonWebhookUrl = $('#reference-webhook-url').val()
      
      if (! title) {
        Swal.showValidationMessage(lang.postback_modal_msg_title)
      }

      const data = {
        title: title,
        buttonWebhookUrl: buttonWebhookUrl
      }

      const labelIds = $('#reference-choose-label').val()
      const labelIdTexts = $('#reference-choose-label option:selected')      
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts) 
      data['labelIds'] = labelIds
      data['labelIdTextsArray'] = labelIdTextsArray

      const labelIdsRemove = $('#reference-remove-label').val()
      const labelIdTextsRemove = $('#reference-remove-label option:selected')      
      const labelIdTextsArrayRemove = selectedOptionsTextArray(labelIdTextsRemove) 
      data['labelIdsRemove'] = labelIdsRemove
      data['labelIdTextsArrayRemove'] = labelIdTextsArrayRemove
      
      if (isSequenceAddonAvailable) {
        const sequenceIdValue = $('#reference-choose-sequence').val()
        const sequenceIdText = $('#reference-choose-sequence option:selected').text()
        data['sequenceIdValue'] = sequenceIdValue
        data['sequenceIdText'] = sequenceIdText

        const sequenceIdValueRemove = $('#reference-remove-sequence').val()
        const sequenceIdTextRemove = $('#reference-remove-sequence option:selected').text()
        data['sequenceIdValueRemove'] = sequenceIdValueRemove
        data['sequenceIdTextRemove'] = sequenceIdTextRemove
      }

      const conversationGroupId = $('#reference-conversation-group').val()
      const conversationGroupText = $('#reference-conversation-group option:selected').text()
      data['conversationGroupId'] = conversationGroupId
      data['conversationGroupText'] = conversationGroupText

      const conversationUserId = $('#reference-conversation-user').val()
      const conversationUserText = $('#reference-conversation-user option:selected').text()
      data['conversationUserId'] = conversationUserId
      data['conversationUserText'] = conversationUserText

      const triggerKeyword = $('#trigger-trigger-keyword').val()
      const triggerMatchingType = $("input[name='trigger-matching-type']:checked").val()
      
      data['triggerKeyword'] = triggerKeyword
      data['triggerMatchingType'] = triggerMatchingType

      return data
    },
  })
}

const hideElementsIfActionButtonIsConnectedBefore = (node) => {
  const connections = getNodeInputConnectionsBySocketName(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON, node)
  if (connections[0]) {
    const nodeConnectedAsOutput = connections[0].output.node
    if (nodeConnectedAsOutput.name === CONST_COMPONENT.ACTION_BUTTON) {
      if ('actionType' in nodeConnectedAsOutput.data) {

        $('.trigger-trigger-keyword-group').addClass('d-none');

        if ('broadcasting' === nodeConnectedAsOutput.data.actionType) {
          $('#reference-choose-label').parent().removeClass('d-block').addClass('d-none')
          $('#reference-choose-sequence').parent().removeClass('d-block').addClass('d-none')
        }
        else{
          $('#reference-choose-label').parent().removeClass('d-none').addClass('d-block')
          $('#reference-choose-sequence').parent().removeClass('d-none').addClass('d-block')
        }
      }
    }
  }
  else
  {
    $('.trigger-trigger-keyword-group').removeClass('d-none');
  }
}

const showElementsIfActionButtonHasSpecificValues = (node) => {
  const connections = getNodeInputConnectionsBySocketName(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON, node)
  if (connections[0]) {
    const nodeConnectedAsOutput = connections[0].output.node
    if (nodeConnectedAsOutput.name === CONST_COMPONENT.ACTION_BUTTON) {

      $('.trigger-trigger-keyword-group').addClass('d-none');

      if (('get-started' === nodeConnectedAsOutput.data.actionType) || ('messenger_engagement_plugin' === nodeConnectedAsOutput.data.actionType)) 
      {
        $('#reference-choose-sequence').parent().removeClass('d-block').addClass('d-none')
      }
      else $('#reference-choose-sequence').parent().removeClass('d-none').addClass('d-block')
    }
  }
  else
  {
    $('.trigger-trigger-keyword-group').removeClass('d-none');
  }
  
}

const hideContentIfConnectedWithActionButton = (node) => {
  const connections = getNodeInputConnectionsBySocketName(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON, node)
  if (connections[0]) {
    $('.trigger-trigger-keyword-group').addClass('d-none');
    const nodeConnectedAsOutput = connections[0].output.node
    if (nodeConnectedAsOutput.name === CONST_COMPONENT.ACTION_BUTTON) {
      if ('actionType' in nodeConnectedAsOutput.data) {
        if ('broadcasting' === nodeConnectedAsOutput.data.actionType) {
          $(".only-for-trigger").addClass('d-none').removeClass('d-block');
        }
        else{
          $(".only-for-trigger").removeClass('d-none').addClass('d-block');
        }
      }
    }
  }
  else
  {
    $('.trigger-trigger-keyword-group').removeClass('d-none');
    $(".only-for-trigger").removeClass('d-none');
  }
}